const initLogoScrollAnimation = () => {
    // Initial state
    var scrollPos = 0;
    // adding scroll event
    window.addEventListener('scroll', function(){
    // detects new state and compares it with the new one
    if ((document.body.getBoundingClientRect()).top > scrollPos) {
            this.document.body.classList.remove('has-scrolled-down')
            this.document.body.classList.add('has-scrolled-top')
    }
        else {
            this.document.body.classList.add('has-scrolled-down')
            this.document.body.classList.remove('has-scrolled-top')
        }
        scrollPos = (document.body.getBoundingClientRect()).top;
    });
}

export {initLogoScrollAnimation}